module.exports = __webpack_public_path__ + "img/caja-ica.165a2536.svg";